import { endpoints as billingDetailsEndpoints } from "./billingDetails/endpoints";
import { endpoints as invoicesEndpoints } from "./invoices/endpoints";
import { endpoints as metadataEndpoints } from "./metadata/endpoints";
import { endpoints as paymentMethodsEndpoints } from "./paymentMethods/endpoints";
import { endpoints as plansEndpoints } from "./plans/endpoints";
import { endpoints as promosEndpoints } from "./promos/endpoints";
import { endpoints as subscriptionsEndpoints } from "./subscriptions/endpoints";

export const apiName = "workspaces";

export const endpoints = {
    ...billingDetailsEndpoints,
    ...invoicesEndpoints,
    ...metadataEndpoints,
    ...paymentMethodsEndpoints,
    ...plansEndpoints,
    ...promosEndpoints,
    ...subscriptionsEndpoints
};
